import React from "react";
import PropTypes from "prop-types";
import { Card, CardHeader, CardContent, Typography } from "@mui/material";

import theme from "../../theme";

const DashboardCard = ({ title, count }) => {
  return (
    <Card className="dashboard-card">
      <CardHeader
        style={{
          borderLeft: `3px solid ${theme.palette.primary.darkYellow}`,
          borderBottom: `1px solid ${theme.palette.primary.lightGray}`,
        }}
        title={title}
        titleTypographyProps={{
          fontSize: "16px",
          fontWeight: "500",
          color: `${theme.palette.primary.darkGray}`,
          fontFamily: "Poppins !important"
        }}
      />
      <CardContent className="text-end">
        <Typography variant="h4" className={"card-content-text"}>
          {count}
        </Typography>
      </CardContent>
    </Card>
  );
};

DashboardCard.prototype = {
  title: PropTypes.string,
  count: PropTypes.number,
};

export default DashboardCard;
